import ContentBox from "../Components/ContentBox"
import { WorkData } from "../Assets/data"
import Slider from "../Components/Slider"
import Layout from "../Components/Layout"
const Work=()=>{
    return(
        <>
        <Layout>
           <Slider/>
           <ContentBox data={WorkData}/>
        </Layout>
       
        </>
    )
}
export default Work